<template>
  <div class="page-container">
    <md-app
      md-mode="fixed">
      <md-app-toolbar md-elevation="1">
        <div class="md-toolbar-row fixed__toolbar">
          <div class="md-toolbar-section-start">
            <ScenarioHeader
              :scenario-id="parseInt($route.params.scenarioId)"
              :scenario-state="scenarioDetails.scenario_state"/>
          </div>
          <div class="md-toolbar-section-end">
            <md-button
              class="md-icon-button  md-raised  md-primary"
              @click="menuVisible = !menuVisible">
              <md-icon>menu</md-icon>
            </md-button>
          </div>
        </div>
      </md-app-toolbar>
      <md-app-content class="page-content">
        <div
          class="table__refine"
          v-if="placesList.length > 0">
          <div class="table__refine--header">
            <div class="custom__head">
              &nbsp;
            </div>
            <div
              class="rotate-45"
              v-for="action in actionsList"
              :key="action.id">
              <div>
                <div>
                  {{ action.number }} - {{ action.label }}
                </div>
              </div>
              <md-tooltip md-direction="bottom">{{ action.label }}</md-tooltip>
            </div>
          </div>
          <div class="table__refine--counter">
            <div
              class="tr table__refine--actions-count"
            >
              <div
                class="place__name">Nombre d'occurrences de l'action</div>
              <div
                class="cell actions-count"
                v-for="(countNumber, index) in actionsCountPlaceList[0]"
                :key="`actions-${ countNumber[0] }-${ countNumber[1]}-${index}`">{{ countNumber[1] }}</div>
            </div>
          </div>
          <div class="table__refine--body">
            <div
              class="tr"
              v-for="place in actionsCountPlaceList[1]"
              :key="place.place_id"
              :class="[place.place_type]">
              <div
                @click="handleCollaspe(place)"
                class="place__name">
                <span>{{ place.place_name }} (<em>{{ place.place_extern_identifier }}</em>)</span>
                <span><i>{{ place.place_identifier }}</i></span>
                <span v-if="place.collapsed === false"><md-icon>expand_more</md-icon></span>
                <span v-else-if="place.collapsed === true"><md-icon>expand_less</md-icon></span>
              </div>
              <div
                class="cell"
                v-for="placeAction in place.actions"
                :key="placeAction.id">
                <span
                  class="span readonly"
                  @click="handleCollaspe(place)"
                  v-if="placeAction.year && placeAction.apply_on_place == false">
                  {{ placeAction.year }} <sup v-if='placeAction.is_min_value'><md-tooltip md-direction="left">Première année d'application de l'action sur ce lieu</md-tooltip>**</sup>
                </span>
                <span
                  :class="['span', { readonly: placeAction.is_ppi || placeAction.is_atypical}]"
                  @click="displayPlaceActionYearDialog(place, placeAction, 'change')"
                  v-if="placeAction.year && placeAction.apply_on_place == true">
                  {{ placeAction.year }}
                  <span
                    class="cell-legend"
                    v-if="placeAction.modified == true">Modifié</span>
                  <span
                    class="cell-legend"
                    v-else-if="placeAction.is_ppi == true">PPI</span>
                  <span
                    class="cell-legend"
                    v-else-if="placeAction.is_atypical == true">Atypique</span>
                </span>
                <span
                  class="span"
                  @click="displayPlaceActionYearDialog(place, placeAction, 'add')"
                  v-else-if='placeAction.is_place_level && placeAction.is_ppi === false'>
                  <md-icon>add</md-icon>
                </span>
              </div>
            </div>
          </div>
        </div>
        <template
          v-if="placesList.length === 0">
          <md-empty-state
            md-icon="warning"
            md-label="Aucune action retenue"
            md-description="Aucune action n'a été retenue pour cette simulation. Veuillez modifier votre paramétrage et effectuer une nouvelle simulation.">
            <md-button
              class="md-primary md-raised"
              :to="{ name: 'Scenario settings', params: { scenarioId: $route.params.scenarioId }}">Modifier votre paramétrage</md-button>
          </md-empty-state>
        </template>
        <md-dialog
          :md-active.sync="showPlaceActionYearDialog">
          <form
            @submit.prevent="submit"
            class="modal">
            <md-dialog-content>
              <div class="md-layout md-gutter md-layout-nowrap">
                <div class="md-layout-item  md-size-30 md-small-size-100">
                  <md-field>
                    <label
                      for="placeId"
                      v-if="placeActionYearDialogType === 'change'">Modifier l'action sur</label>
                    <label
                      for="placeId"
                      v-else>Ajouter l'action sur</label>
                    <md-input
                      type="hidden"
                      name='placeId'
                      v-model="placeactionyear.placeId" />
                    <md-input
                      v-model="placeactionyear.placeLabel"
                      readonly />
                    <md-tooltip md-direction="top">{{ placeactionyear.placeLabel }}</md-tooltip>
                  </md-field>
                </div>
                <div class="md-layout-item  md-size-50 md-small-size-100">
                  <md-field>
                    <input
                      type="hidden"
                      name='actionId'
                      v-model="placeactionyear.actionId">
                    <label for="actionId">Action</label>
                    <md-input
                      v-model="placeactionyear.actionLabel"
                      readonly />
                    <md-tooltip md-direction="top">{{ placeactionyear.actionLabel }}</md-tooltip>
                  </md-field>
                </div>
                <div class="md-layout-item  md-size-20 md-small-size-100">
                  <md-field>
                    <label for="year">Année</label>
                    <md-select
                      v-model="placeactionyear.year"
                      name="year">
                      <md-option
                        v-for="actionYear in actionYears"
                        :key='actionYear'
                        :value="actionYear">{{ actionYear }}</md-option>
                    </md-select>
                  </md-field>
                </div>
              </div>
            </md-dialog-content>
            <md-dialog-content>
              <md-divider />
            </md-dialog-content>
            <md-dialog-actions>
              <md-button
                v-if="placeActionYearDialogType === 'change'"
                @click="updatePlaceActionYear(placeactionyear, true)"
                class="md-accent">Supprimer cette action</md-button>
              <md-button
                @click="updatePlaceActionYear(placeactionyear, false)"
                class="md-primary">Valider</md-button>
            </md-dialog-actions>
          </form>
        </md-dialog>

        <md-dialog
          :md-active.sync="showPlaceAddActionDialog">
          <form
            @submit.prevent="submit"
            class="modal">
            <md-dialog-content>
              <div class="md-layout md-gutter md-layout-nowrap">
                <div class="md-layout-item  md-size-30 md-small-size-100">
                  <md-field>
                    <label
                      for="placeId">Ajouter une action sur</label>
                    <md-input
                      type="hidden"
                      name='placeId'
                      v-model="placeaddaction.placeId" />
                    <md-input
                      v-model="placeaddaction.placeLabel"
                      readonly />
                    <md-tooltip md-direction="top">{{ placeaddaction.placeLabel }}</md-tooltip>
                  </md-field>
                </div>
                <div class="md-layout-item  md-size-50 md-small-size-100">
                  <md-field>
                    <md-select
                      v-model="placeaddaction.actionId"
                      name="add-action-id"
                      id="addActionId">
                      <md-option
                        v-for='addAction in placeaddaction.addActionList'
                        :key='addAction.id'
                        :value='addAction.id'>{{ addAction.number }} - {{ addAction.label }}
                      </md-option>
                    </md-select>
                    <label for="addActionId">Action</label>
                  </md-field>
                </div>
                <div class="md-layout-item  md-size-20 md-small-size-100">
                  <md-field>
                    <label for="year">Année</label>
                    <md-select
                      v-model="placeaddaction.year"
                      name="year">
                      <md-option
                        v-for="actionYear in actionYears"
                        :key='actionYear'
                        :value="actionYear">{{ actionYear }}</md-option>
                    </md-select>
                  </md-field>
                </div>
              </div>
            </md-dialog-content>
            <md-dialog-content>
              <md-divider />
            </md-dialog-content>
            <md-dialog-actions>
              <md-button
                @click="showPlaceAddActionDialog = false"
                class="md-accent">Annuler</md-button>
              <md-button
                @click="createPlaceActionYear(placeaddaction)"
                class="md-primary">Valider</md-button>
            </md-dialog-actions>
          </form>
        </md-dialog>
        <md-dialog
          :md-active.sync="showDeletedPlaceAddActionDialog">
          <md-dialog-content>
            <md-table
              v-model="deletedPlaceActions"
              md-sort="place_name"
              md-sort-order="asc">
              <md-table-toolbar>
                <h1 class="md-title">Liste des actions exclues</h1>
              </md-table-toolbar>
              <md-table-row
                slot="md-table-row"
                slot-scope="{ item }">
                <md-table-cell
                  md-label="Lieu"
                  md-sort-by="place_name">
                  {{ item.place_name }}</md-table-cell>
                <md-table-cell
                  md-sort-by="action"
                  md-label="Action"
                >{{ item.action }}</md-table-cell>
                <md-table-cell
                  md-label="Économie"
                ><template v-if="item.economy === 0">{{ item.economy }}€</template><template v-else> - </template></md-table-cell>
                <md-table-cell
                  md-label="Temps de retour"
                ><template v-if="item.return_time !== 1000">{{ item.return_time }} années</template>
                <template v-else> - </template></md-table-cell>
              </md-table-row>
            </md-table>
            <md-divider />
          </md-dialog-content>
          <md-dialog-actions>
            <md-button
              @click="showDeletedPlaceAddActionDialog = false"
              class="md-accent">Fermer</md-button>
          </md-dialog-actions>
        </md-dialog>
      </md-app-content>
      <md-app-drawer
        :md-active.sync="menuVisible"
        class="filters">
        <template>
          <div>
            <md-button
              :disabled="!deletedPlaceActions || !deletedPlaceActions.length"
              class="md-raised"
              @click="showDeletedPlaceAddActionDialog = true">
              <md-icon>info</md-icon> Voir les actions exclues
            </md-button>
            <div class="filters-title page-title">Filtres</div>
            <md-field>
              <label>Filtrer par nom de site</label>
              <md-input v-model="placesName" />
            </md-field>
            <md-field>
              <label for="geoplace">Filtrer par localité</label>
              <md-select
                v-model="selectedGeoPlace"
                name="geoplace"
                id="geoplace">
                <md-option
                  v-for='geoPlace in geoPlaceList'
                  :key='geoPlace.geonameid'
                  :value='geoPlace.geonameid'>{{ geoPlace.name }}
                </md-option>
              </md-select>
            </md-field>
          </div>
          <md-table
            v-model="functionsList"
            :md-selected-value="selectedFunctions"
            @md-selected="onFunctionsSelect">
            <md-table-toolbar>
              <div class="filters-title">Fonctions des sites</div>
            </md-table-toolbar>

            <md-table-row
              slot="md-table-row"
              slot-scope="{ item }"
              md-selectable="multiple"
              md-auto-select>
              <md-table-cell
                md-label="Fonction">{{ item.label }}</md-table-cell>
              <md-table-cell
                md-label="Sites">{{ item.places_count }}</md-table-cell>
            </md-table-row>
          </md-table>
          <md-table
            v-model="tagsList"
            :md-selected-value="selectedTags"
            @md-selected="onTagsSelect">
            <md-table-toolbar>
              <div class="filters-title">Tags</div>
            </md-table-toolbar>

            <md-table-row
              slot="md-table-row"
              slot-scope="{ item }"
              md-selectable="multiple"
              md-auto-select>
              <md-table-cell
                md-label="Tag">{{ item.name }}</md-table-cell>
              <md-table-cell
                md-label="Sites">{{ item.places_count }}</md-table-cell>
            </md-table-row>
          </md-table>
        </template>
      </md-app-drawer>
    </md-app>
  </div>
</template>
<script>
import session from '../api/session'
import axios from 'axios'
import ScenarioHeader from '../components/ScenarioHeader.vue'
import zip from 'lodash/zip'

function stringToSlug (str) {
  str = str.replace(/^\s+|\s+$/g, '')
  str = str.toLowerCase()

  // remove accents, swap ñ for n, etc
  var from = 'åàáãäâèéëêìíïîòóöôùúüûñç·/_,:;'
  var to = 'aaaaaaeeeeiiiioooouuuunc------'

  for (var i = 0, l = from.length; i < l; i++) {
    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
  }

  str = str
    .replace(/[^a-z0-9 -]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')

  return str
}

export default {
  name: 'ScenarioRefine',
  components: {
    ScenarioHeader
  },
  data () {
    return {
      showPlaceActionYearDialog: false,
      showPlaceAddActionDialog: false,
      showDeletedPlaceAddActionDialog: false,
      placeActionYearDialogType: '',
      actionsList: [],
      addActionsList: [],
      addActionsTypeList: [],
      scenarioDetails: {scenario_state: 'new'},
      placesList: [],
      deletedPlaceActions: [],
      foldedPlaces: [],
      functionsList: [],
      tagsList: [],
      geoPlaceList: [],
      selectedFunctions: [],
      selectedFunctionIds: [],
      selectedTags: [],
      selectedTagsIds: [],
      actionYears: [],
      selectedGeoPlace: null,
      placesName: null,
      menuVisible: false,

      placeactionyear: {
        placeId: null,
        actionId: null,
        placeLabel: null,
        year: null,
        actionLabel: null
      },
      placeaddaction: {
        addActionList: [],
        placeId: null,
        actionId: null,
        placeLabel: null,
        year: null,
        actionLabel: null
      }
    }
  },
  mounted: function () {
    this.$store.dispatch('routing/update_title', 'Affinage')
    this.$store.dispatch('routing/update_return_kwargs', null)
    this.loadApi()
  },
  computed: {
    actionsCountPlaceList () {
      let app = this
      let actionsCount = {}

      /* Filter on function */
      let filteredPlaces = app.placesList
      if (app.selectedFunctionIds.length > 0) {
        filteredPlaces = filteredPlaces.filter(function (place) {
          return app.selectedFunctionIds.indexOf(place['place_function_id']) >= 0
        })
      }

      /* Filter on tags */
      if (app.selectedTagsIds.length > 0) {
        filteredPlaces = filteredPlaces.filter(function (place) {
          let placeTags = place['tags'].map(t => t['id'])
          let hasAllTags = true
          app.selectedTagsIds.forEach(tagId => {
            if (!placeTags.includes(tagId)) {
              hasAllTags = false
            }
          })
          return hasAllTags
        })
      }

      filteredPlaces = filteredPlaces.filter(function (place) {
        return app.foldedPlaces.indexOf(place['place_id']) === -1
      })

      if (app.placesName) {
        filteredPlaces = filteredPlaces.filter(function (place) {
          let searchSlug = stringToSlug(app.placesName)
          return stringToSlug(place['search_place_name']).indexOf(searchSlug) > -1
        })
      }

      if (app.selectedGeoPlace) {
        filteredPlaces = filteredPlaces.filter(function (place) {
          for (let i in place.place_localities) {
            if (place.place_localities[i] === app.selectedGeoPlace) {
              return true
            }
          }
        })
      }

      let placeListids = []
      filteredPlaces.forEach(place => {
        placeListids.push(place.place_id)
        place.place_childs.forEach(childId => {
          placeListids.push(childId)
        })
      })

      app.placesList.forEach(place => {
        place.actions.forEach(action => {
          if (!Object.keys(actionsCount).includes(action.number.toString())) {
            actionsCount[action.number] = 0
          }
          if (action.apply_on_place && action.year !== null) {
            if (placeListids.includes(place.place_id)) {
              actionsCount[action.number]++
            }
          }
        })
      })

      return [zip(Object.keys(actionsCount), Object.values(actionsCount)), filteredPlaces]
    }
  },
  methods: {
    onFunctionsSelect (items) {
      this.selectedFunctions = items
    },
    onTagsSelect (items) {
      this.selectedTags = items
    },
    handleCollaspe: function (place) {
      var app = this
      var childPlace = null
      place.collapsed = !place.collapsed

      if (!place.collapsed) {
        for (var i in place.place_childs) {
          if (app.foldedPlaces.indexOf(place.place_childs[i]) === -1) {
            app.foldedPlaces.push(place.place_childs[i])
          }
          childPlace = app.placesList[app.placesList.findIndex(function (p) { return p.place_id === place.place_childs[i] })]

          if (childPlace.place_type !== 'area') {
            childPlace.collapsed = false
          }
        }
      } else {
        for (var j in place.place_childs) {
          app.foldedPlaces.splice(app.foldedPlaces.indexOf(place.place_childs[j]), 1)
          childPlace = app.placesList[app.placesList.findIndex(function (p) { return p.place_id === place.place_childs[j] })]

          if (childPlace.place_type !== 'area') {
            childPlace.collapsed = true
          }
        }
      }
    },
    canAddActionOnPlace: function (place) {
      let app = this
      return app.addActionsTypeList.indexOf(place.place_type) > -1
    },
    displayPlaceAddActionDialog: function (place) {
      let app = this
      app.placeaddaction.placeId = place.place_id
      app.placeaddaction.placeLabel = place.place_name

      app.placeaddaction.addActionList = app.addActionsList.filter(function (addAction) {
        return addAction.place_type === place.place_type
      })

      app.showPlaceAddActionDialog = !app.showPlaceAddActionDialog
    },
    displayPlaceActionYearDialog: function (place, placeAction, operation) {
      let app = this

      if (placeAction.is_ppi === false && placeAction.is_atypical === false) {
        let action = app.actionsList[app.actionsList.findIndex(function (a) { return a.id === placeAction.id })]

        app.placeActionYearDialogType = operation
        app.placeactionyear.placeId = place.place_id
        app.placeactionyear.placeLabel = place.place_name
        app.placeactionyear.actionId = action.id
        app.placeactionyear.actionLabel = action.label
        app.placeactionyear.year = placeAction.year
        app.showPlaceActionYearDialog = !app.showPlaceActionYearDialog
      }
    },
    updatePlaceActionYear ({ placeId, actionId, year }, remove) {
      var app = this
      var scenarioId = app.$route.params.scenarioId
      var place = app.placesList[app.placesList.findIndex(function (p) { return p.place_id === placeId })]
      var placeAction = place.actions[place.actions.findIndex(function (a) { return a.id === actionId })]

      if (remove === true) {
        year = null
      }

      if (placeAction.year !== year) {
        app.$store.dispatch('loading/begin_loading')

        session.post(`/api/scenario/refine/${scenarioId}/update/`, {'place': placeId, 'action': actionId, 'year': year})
          .then(function (response) {
            // Reload the data from server
            session.get(`/api/scenario/refine/${scenarioId}/retrieve/`).then(function (placesResponse) {
              app.placesList = placesResponse.data.places_list
              app.$store.dispatch('loading/end_loading')
            }).catch(function (error) {
              console.log(error)
            })
          })
          .catch(function (error) {
            console.log(error)
          })
      }
      app.showPlaceActionYearDialog = !app.showPlaceActionYearDialog
    },
    createPlaceActionYear ({ placeId, actionId, year }) {
      var app = this
      var scenarioId = app.$route.params.scenarioId

      session.post(`/api/scenario/refine/${scenarioId}/update/`, {'place': placeId, 'action': actionId, 'year': year})
        .then(function (response) {
          // Reload the whole data from the server to refresh the ui
          app.loadApi()
          app.showPlaceAddActionDialog = !app.showPlaceAddActionDialog
        })
        .catch(function (error) {
          var response = error.response
          if (response.status === 500) {
            app.showPlaceAddActionDialog = false
          }
        })
    },
    loadApi: function () {
      var app = this
      var scenarioId = this.$route.params.scenarioId
      let scenarioDetailsRequest = session.get(`/api/scenario/${scenarioId}/`)
      let geoPlaceRequest = session.get(`/api/scenario/${scenarioId}/geo_places/`)
      let functionsRequest = session.get(`/api/scenario/${scenarioId}/functions/`)
      let tagsRequest = session.get(`/api/scenario/${scenarioId}/tags/`)
      let placesRequest = session.get(`/api/scenario/refine/${scenarioId}/retrieve/`)
      let actionsRequest = session.get(`/api/scenario/refine/${scenarioId}/actions/`)
      let addActionRequest = session.get(`/api/scenario/refine/${scenarioId}/actions/add/`)

      app.$store.dispatch('loading/begin_loading')

      axios.all([scenarioDetailsRequest, placesRequest, functionsRequest, actionsRequest, tagsRequest, geoPlaceRequest, addActionRequest])
        .then(axios.spread(function (scenarioDetailsResponse, placesResponse, functionResponse, actionsResponse, tagsResponse, geoPlaceResponse, addActionResponse) {
          app.scenarioDetails = scenarioDetailsResponse.data
          app.placesList = placesResponse.data.places_list
          app.deletedPlaceActions = placesResponse.data.deleted_place_actions
          app.geoPlaceList = geoPlaceResponse.data
          app.actionsList = actionsResponse.data
          app.addActionsList = addActionResponse.data

          if (app.scenarioDetails.generating) {
            app.$router.push({name: 'Scenarios list'})
          }

          /*
            ugly workaround for a bug in vue-material
            https://github.com/vuematerial/vue-material/issues/1904
          */
          setTimeout(async () => {
            app.$set(app, 'functionsList', functionResponse.data)
            await app.$nextTick()
            app.selectedFunctions = app.functionsList

            app.$set(app, 'tagsList', tagsResponse.data)
            await app.$nextTick()
            app.selectedTags = app.tagsList
          }, 300)

          app.$store.dispatch('routing/update_title', app.scenarioDetails.label)

          app.geoPlaceList.unshift({'geonameid': '', 'name': 'Toutes les localités'})

          var minYear = app.scenarioDetails.year
          let maxYear = app.scenarioDetails.scenario_end_year
          let nbYears = maxYear - minYear + 1
          app.actionYears = Array.from(new Array(nbYears), (val, index) => index + minYear)

          for (var i in app.functionsList) {
            app.selectedFunctions.push(app.functionsList[i]['id'])
          }

          for (i in app.addActionsList) {
            if (app.addActionsTypeList.indexOf(app.addActionsList[i]['place_type']) === -1) {
              app.addActionsTypeList.push(app.addActionsList[i]['place_type'])
            }
          }

          for (i in app.placesList) {
            if (app.placesList[i]['place_type'] !== 'site') {
              app.foldedPlaces.push(app.placesList[i]['place_id'])
            }

            if (app.placesList[i]['place_type'] !== 'area') {
              app.placesList[i].collapsed = false
            }
          }
          app.$store.dispatch('loading/end_loading')
        }))
    }
  },
  watch: {
    selectedFunctions: {
      immediate: true,
      handler: function (value) {
        var app = this
        app.selectedFunctionIds = []
        if (app.functionsList.length !== app.selectedFunctions.length) {
          app.selectedFunctionIds = app.selectedFunctions.map(func => func.id)
        }
      }
    },
    selectedTags: {
      immediate: true,
      handler: function (value) {
        var app = this
        app.selectedTagsIds = []
        if (app.tagsList.length !== app.selectedTags.length) {
          app.selectedTagsIds = app.selectedTags.map(tag => tag.id)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../stylesheets/variables";

.page-content {
  overflow: auto;
  height: calc(100vh - 64*2px);
}

.md-layout {
  margin-top: 10px;
}

.span {
  display: block;
  text-align: center;

  &:not(.readonly) {
    cursor: pointer;
  }
}
.tr {
  border-bottom: 1px solid #ddd;
}
.nav {
  ol {
    display: flex;
    li {
      margin-right: 2rem;
    }
  }
}
.md-table-row {
  border-bottom: 1px solid #eee;
}
.area {
  background-color: rgba(rgb(208, 255, 0), 0.3);
}
.building {
  background-color: rgba(rgb(208, 255, 0), 0.5);
}
.modal {
  label {
    display: block;
    font-size: 12px;
    color: darken(white, 30);
  }
}
.cell-legend {
  font-size: 10px;
  font-weight: bold;
  text-align: center;
  display: block;
}

.filters{
  width: 300px;
  padding-left: 20px;
  padding-right: 20px;
  right: 0 !important;
  left: unset;
  top: 64px;
  transform: translate3D(100%,0,0);
  &.md-drawer.md-active{
    transform: translate3D(0%,0,0);
  }

  padding-left: 20px;

  .filters-field{
    padding: 0 16px;
  }
}

.filters-title {
    font-weight: bold;
    font-size: 18px;
    color: #86ad19;
    padding-top:0;
    padding-bottom:0;
    margin-bottom: -20px;

    &.simple-card-title{
      padding: 1em;
    }

    &.page-title{
      margin-bottom: 0px;
      margin-top: 20px;
    }
}

.table__refine {
  border-right: 0;
  width: 100%;

  table td {
    &:not(.place__name) {
      width: 40px;

      .md-table-cell-container {
        align-items: center;
        display: flex;
        justify-content: center;
        padding: 0;

        .md-icon {
          color: #999;
          font-size: 16px !important;
        }
      }
    }
  }

  .building {
    div:first-child {
      padding-left: 30px;
    }
  }

  .area {
    div:first-child {
      padding-left: 50px;
    }
  }

  .place__name {
    font-weight: bold;
    min-width: 400px;
    padding-left: 10px;
    width: 400px;

    .md-icon {
      background: rgba(project-theme('primary'), .4);
      border-radius: 50%;
      margin-left: 10px;
      transform: scale(.6);
    }
  }

  .md-table table {
    overflow: visible;
  }
}

.table__refine {
  display: table;

  .rotate-45,
  .cell {
    min-width: 50px;
    text-align: left;
    width: 50px;
    &.actions-count{
      text-align: center;
    }
  }
  .rotate-45 {
    >div>div {
      padding: 10px;
    }
  }
}

.table__refine--header {
  border-bottom: 2px solid project-theme('background');
  display: flex;
}

.table__refine--body {
  overflow: scroll;
  height: calc(100vh - 445px);
  .tr {
    display: flex;
    padding: 10px 0;
  }
}

.table__refine--counter {
  .tr {
    display: flex;
    padding: 10px 0;
  }
}

.table__refine--actions-count{
    background-color: project-theme("background");
    font-weight: bold;
}

</style>



// WEBPACK FOOTER //
// src/views/ScenarioRefine.vue